import type { ApiErrorResponse } from '@/lib/auth/types';

const ABSOLUTE_URL_REGEX = /^https?:\/\//i;

export class ApiClientError extends Error {
  status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'ApiClientError';
    this.status = status;
  }
}

export function hasApiBaseUrl(): boolean {
  return Boolean(process.env.NEXT_PUBLIC_API_BASE_URL?.trim());
}

export function getApiBaseUrl(): string {
  const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL?.trim();

  if (!apiBaseUrl) {
    throw new ApiClientError('Configura NEXT_PUBLIC_API_BASE_URL para consumir el backend.');
  }

  return apiBaseUrl.replace(/\/+$/, '');
}

export function buildApiUrl(pathOrUrl: string): string {
  const normalizedPathOrUrl = pathOrUrl.trim();

  if (!normalizedPathOrUrl) {
    throw new ApiClientError('Configura un endpoint valido para continuar.');
  }

  if (ABSOLUTE_URL_REGEX.test(normalizedPathOrUrl)) {
    return normalizedPathOrUrl;
  }

  const apiBaseUrl = getApiBaseUrl();
  return `${apiBaseUrl}/${normalizedPathOrUrl.replace(/^\/+/, '')}`;
}

export async function parseJson<T>(response: Response): Promise<T | null> {
  try {
    return (await response.json()) as T;
  } catch {
    return null;
  }
}

export function getApiErrorMessage(payload: ApiErrorResponse | null): string | null {
  if (typeof payload?.details === 'string' && payload.details.trim().length > 0) {
    return payload.details;
  }

  if (
    payload?.error &&
    typeof payload.error === 'object' &&
    typeof payload.error.message === 'string' &&
    payload.error.message.trim().length > 0
  ) {
    return payload.error.message;
  }

  if (typeof payload?.message === 'string' && payload.message.trim().length > 0) {
    return payload.message;
  }

  if (typeof payload?.error === 'string' && payload.error.trim().length > 0) {
    return payload.error;
  }

  return null;
}
